import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import { showImagePreview } from 'vant';
export default {
  props: {
    srcs: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {},
  data: function data() {
    return {};
  },
  computed: {
    srcArrays: function srcArrays() {
      return this.srcs.map(function (src) {
        return {
          src: src,
          key: new Date().getTime() + Math.random()
        };
      });
    }
  },
  methods: {
    handlePreview: function handlePreview(images, image) {
      var startPosition = images.findIndex(function (url) {
        return url === image;
      });
      showImagePreview({
        images: images,
        startPosition: startPosition
      });
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  beforeUnmount: function beforeUnmount() {},
  watch: {}
};